// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"G276524","label":"G2aad38 G5c5f3b G2f6568 Gd71c60"};